// extracted by mini-css-extract-plugin
export default {"profileLinks":"Profile_profileLinks__i4+Tx","icon":"Profile_icon__Lff4h"};